const initialState = {
  unitsVisible: true, // Видимость слоя отрядов
  hexCoordinatesVisible: false, // Видимость координат ячеек
  incomeVisible: false, // Видимость дохода ключевых точек
  cityOwnershipVisible: false, // Видимость слоя принадлежности городов
  blockedCellsVisible: true, // Видимость слоя заблокированных ячеек
  guildVisible: false, // Видимость слоя гильдий
  templeVisible: false, // Видимость слоя храмов
  fortressVisible: true, // Видимость слоя крепостей
  quarterZoneVisible: false, // Видимость слоя зоны влияния кварталов
};

const layersReducer = (state = initialState, action) => {
  switch (action.type) {
    case 'TOGGLE_UNITS_VISIBLE': {
      return {
        ...state,
        unitsVisible: !state.unitsVisible
      };
    }

    case 'TOGGLE_HEX_COORDINATES_VISIBLE': {
      return {
        ...state,
        hexCoordinatesVisible: !state.hexCoordinatesVisible
      };
    }

    case 'TOGGLE_INCOME_VISIBLE': {
      return {
        ...state,
        incomeVisible: !state.incomeVisible
      };
    }

    case 'TOGGLE_CITY_OWNERSHIP_VISIBLE': {
      return {
        ...state,
        cityOwnershipVisible: !state.cityOwnershipVisible
      };
    }

    case 'TOGGLE_BLOCKED_CELLS_VISIBLE': {
      return {
        ...state,
        blockedCellsVisible: !state.blockedCellsVisible
      };
    }

    case 'TOGGLE_GUILD_VISIBLE': {
      return {
        ...state,
        guildVisible: !state.guildVisible
      };
    }

    case 'TOGGLE_TEMPLE_VISIBLE': {
      return {
        ...state,
        templeVisible: !state.templeVisible
      };
    }

    case 'TOGGLE_FORTRESS_VISIBLE': {
      return {
        ...state,
        fortressVisible: !state.fortressVisible
      };
    }

    case 'TOGGLE_QUARTER_ZONE_VISIBLE': {
      return {
        ...state,
        quarterZoneVisible: !state.quarterZoneVisible
      };
    }

    case 'SET_QUARTER_ZONE_VISIBLE': {
      return {
        ...state,
        quarterZoneVisible: action.payload
      };
    }

    default:
      return state;
  }
};

export default layersReducer;
